import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PaymentMethod } from '../models/payment_method.model';
import { GraphQLService } from './graphql.service';
import { HttpClient } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';

import paymentMethodsQuery from 'src/app/graphql/queries/payment_methods.query.graphql'

@Injectable()
export class PaymentMethodService extends GraphQLService<PaymentMethod> {

  constructor(
    http: HttpClient,
    snackBar: MatSnackBar
  ) {
    super(http, snackBar)
  }

  getPaymentMethods(amount: number, currency: string): Observable<PaymentMethod[]> {
    return this.findAll(paymentMethodsQuery, {amount: amount, currency: currency})
  }

}
